import { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import { STATIC } from "@/data/content";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import CaseStudyDetail from "@/pages/CaseStudyDetail";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useLenis();
  return (
    <div className={`App grain ${STATIC ? "gt-static" : ""}`}>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Home />
                <WhatsAppFloat />
              </>
            }
          />
          <Route path="/work/:id" element={<CaseStudyDetail />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
